import * as React from 'react';

import { LOCAL_STORAGE_IS_DESKTOP_FILTERS_WERE_APPLIED } from '../../../../../../shared/common/hooks/useUxFbPoll/constants';
import {
  getLocalStorageFiltersWereAppliedTwoTimes,
  setLocalStorageFiltersApplied,
} from '../../../../../../shared/common/hooks/useUxFbPoll/localStorageUtils';
import { getTermsValue, NonEmptyArray } from '../../../../../JsonQuery';
import { ERoomType } from '../../../../../api-models/common/json_query';
import { RoomType } from '../../../components/filters/RoomType';
import { useFiltersContext } from '../../../utils/useFiltersContext';

export const RoomTypeContainer: React.FC = () => {
  const { jsonQuery, onChange, onApply } = useFiltersContext();
  const roomType = getTermsValue('room')(jsonQuery);
  const isLocalStorageFiltersWereAppliedTwoTimes = getLocalStorageFiltersWereAppliedTwoTimes(
    LOCAL_STORAGE_IS_DESKTOP_FILTERS_WERE_APPLIED,
  );

  const handleChange = React.useCallback(
    (roomType: NonEmptyArray<ERoomType> | null) => {
      onChange({ action: 'setRoomTypes', arguments: [roomType] });
      onApply();

      //Если фильтр был применен 2 раза, сохраняем значеине в LocalStorage
      if (!isLocalStorageFiltersWereAppliedTwoTimes) {
        setLocalStorageFiltersApplied(LOCAL_STORAGE_IS_DESKTOP_FILTERS_WERE_APPLIED);
      }
    },
    [onChange, onApply, isLocalStorageFiltersWereAppliedTwoTimes, setLocalStorageFiltersApplied],
  );

  return <RoomType value={roomType} onChange={handleChange} />;
};
